import { render, staticRenderFns } from "./FeatureOn.vue?vue&type=template&id=6f4a637e"
import script from "./FeatureOn.vue?vue&type=script&lang=ts"
export * from "./FeatureOn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports